module.exports = __webpack_public_path__ + "static/img/005.c86fe422.png";